
























































































































































import Reflect from "reflect-metadata";
import { Component, Vue, Watch } from "vue-property-decorator";
import { User } from "@/models/User";
import { dniFilter } from "@/filters/DniFilter";
import userService, { UserSearch } from "@/services/UserService";
import session from "@/services/SessionService";

import DeleteUserDialog from "@/components/DeleteUserDialog.vue";
import UserFiltersMenu from "@/components/UserFiltersMenu.vue";
import searchService, { SearchFilter } from "../../services/SearchService";

@Component({
  filters: {
    dni: dniFilter,
  },
  components: {
    DeleteUserDialog,
    UserFiltersMenu,
  },
})
export default class UserIndex extends Vue {
  loading: boolean = false;
  sessionUser: User | null;
  headers = [
    {
      text: "",
      sortable: false,
    },
    {
      text: "Nombre",
      value: "full_name",
      align: "left",
    },
    {
      text: "Email",
      value: "email",
      align: "left",
    },
    {
      text: "Contacto",
      value: "contact_id",
      align: "left",
    },
    {
      text: "Admin",
      value: "is_admin",
      align: "center",
    },
  ];

  constructor() {
    super();
    this.sessionUser = session.getUser();
    this.search = {
      pagination: searchService.pagination,
      filters: searchService.filters,
    };
    if (this.sessionUser && this.sessionUser.is_superadmin) {
      this.headers.push({
        text: "Superadmin",
        value: "is_superadmin",
        align: "center",
      });
    }
    this.headers.push({
      text: "Validado",
      value: "validated",
      align: "center",
    });
  }

  users: User[] | User | undefined = [];
  selected: User[] = [];

  search: UserSearch;
  totalUsers: number = 0;

  loadUsers() {
    this.loading = true;
    userService
      .get(this.search)
      .then((response) => {
        this.users = response.data ? response.data.users : [];
        this.search.pagination = response.data
          ? response.data.pagination
          : this.search.pagination;
        this.totalUsers = response.data
          ? (response.data.pagination.totalItems as number)
          : this.totalUsers;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  removeFilter(key: string) {
    let prev = this.search.filters.findIndex((filter) => {
      return filter.key == key;
    });
    if (prev >= 0) {
      this.search.filters.splice(prev, 1);
    }
  }

  @Watch("search", { deep: true })
  reloadData() {
    if (!this.loading) this.loadUsers();
  }

  mounted() {
    this.$root.$on("load:users", () => {
      this.loadUsers();
    });

    this.$root.$on("filter:apply", (filters: SearchFilter[]) => {
      filters.forEach((filter) => {
        let prev = this.search.filters.findIndex((item) => {
          return item.key == filter.key;
        });
        if (prev >= 0) {
          this.search.filters.splice(prev, 1);
        }

        this.search.filters.push(filter);
      });
    });

    this.loadUsers();
  }
}
